import { render } from "./AdditionalComparison.vue?vue&type=template&id=11422979&scoped=true"
import script from "./AdditionalComparison.vue?vue&type=script&lang=js"
export * from "./AdditionalComparison.vue?vue&type=script&lang=js"

import "./AdditionalComparison.vue?vue&type=style&index=0&id=11422979&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11422979"]])

export default __exports__